export const parseCortexUrl = (cortexUrl) => {
    const url = new URL(cortexUrl);
    const { hostname } = url;
    const envMatch = hostname.match(/^api([.-])?(.*)\.medable\.(com|cn|tech)$/);
    if (!envMatch) {
        return null;
    }
    const [, , env = '', tld] = envMatch;
    return { env, tld };
};
export const extractClassicAppsBaseUrl = (cortexUrl, appName) => {
    const parsed = parseCortexUrl(cortexUrl);
    if (!parsed) {
        return `https://${appName}.medable.com`;
    }
    const { env, tld } = parsed;
    if (!env) {
        return `https://${appName}.medable.${tld}`;
    }
    let separator = '-';
    switch (true) {
        case env === 'local':
            separator = '.';
            break;
        case ['portal', 'mystudy'].includes(appName) && (env === 'qa' || env === 'dev') && tld !== 'cn':
            separator = '.';
            break;
        default:
            separator = '-';
    }
    return `https://${appName}${separator}${env}.medable.${tld}`;
};
export const buildDocumentUrl = (documentId, environment) => {
    if (!environment) {
        return '';
    }
    const appUrl = extractClassicAppsBaseUrl(environment.cortexURL, 'site');
    return `${appUrl}/documents/${documentId}?orgCode=${environment.code}`;
};
export const buildDocumentCreateUrl = (participantId, environment) => {
    if (!environment || !participantId) {
        return '';
    }
    const appUrl = extractClassicAppsBaseUrl(environment.cortexURL, 'site');
    const createDocumentURL = `${appUrl}/documents/create`;
    return `${createDocumentURL}/participant/${participantId}?orgCode=${environment.code}`;
};
